<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">姓名：</span>
					<el-input v-model="backer_name" class="b_inp" placeholder="姓名"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">手机号码：</span>
					<el-input v-model="backer_phone" class="b_inp" placeholder="手机号码"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">创建人：</span>
					<el-input v-model="backer_creater" class="b_inp" placeholder="创建人"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="backer_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="backer_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="exportExcel">导出数据</el-button>
				<el-button type="primary" @click="handleAddBackerClick">新增后台管理者</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="phone"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="creater"
						label="创建人"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewBackerClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleResetPasswordClick(scope.row)"
							>重置密码</el-button>
							<el-button
								v-if="authInfo.ucategory == 1"
								@click="handleRelatedOrganizationClick(scope.row)"
							>关联机构</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增后台管理者弹出框 -->
		<Popup 
			v-model="addBacker_popup_display"
			title="新增后台用户"
			confirmBtnText="添加"
			@confirmClick="handleAddBackerPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
					<el-input v-model="addBacker_name" placeholder="姓名"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addBackerName_tip"><i class="b_icon"></i>请输入后台用户姓名</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
					<el-input v-model="addBacker_phone" placeholder="手机号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addBackerPhone_tip"><i class="b_icon"></i>手机号格式错误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>区域</span>
					<VDistpicker @province="handleAddBackerAddrProvinceSelect" @city="handleAddBackerAddrCitySelect" @area="handleAddBackerAddrAreaSelect"></VDistpicker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addBackerAddr_tip"><i class="b_icon"></i>请选择区域</template></div>
			</div>
		</Popup>
		<!-- 新增后台管理者弹出框 end -->
		
		<!-- 查看后台管理者弹出框 -->
		<Popup 
			v-model="viewBacker_popup_display"
			title="后台用户详情"
			confirmBtnText="修改"
			@confirmClick="handleUpdateBackerClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label">姓名</span>
					<el-input :value="viewBacker_name" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">账号</span>
					<el-input :value="viewBacker_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建人</span>
					<el-input :value="viewBacker_creater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建时间</span>
					<el-input :value="viewBacker_creatDate" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改人</span>
					<el-input :value="viewBacker_updater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改时间</span>
					<el-input :value="viewBacker_updateDate" disabled></el-input>
				</div>
			</div>
		</Popup>
		<!-- 查看后台管理者弹出框 end -->
		
		<!-- 修改后台管理者弹出框 -->
		<Popup 
			v-model="updateBacker_popup_display"
			title="更新后台用户"
			@confirmClick="handleUpdateBackerPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>账号</span>
					<el-input :value="updateBacker_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
					<el-input v-model="updateBacker_name" placeholder="姓名"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateBackerName_tip"><i class="b_icon"></i>请输入后台用户姓名</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
					<el-input v-model="updateBacker_phone" placeholder="手机号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateBackerPhone_tip"><i class="b_icon"></i>手机号格式错误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>区域</span>
					<VDistpicker :province="updateBacker_addr.provinceName" :city="updateBacker_addr.cityName" :area="updateBacker_addr.areaName" @province="handleUpdateBackerAddrProvinceSelect" @city="handleUpdateBackerAddrCitySelect" @area="handleUpdateBackerAddrAreaSelect"></VDistpicker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateBackerAddr_tip"><i class="b_icon"></i>请选择区域</template></div>
			</div>
		</Popup>
		<!-- 修改后台管理者弹出框 end -->
		
		<!-- 重置密码弹出框 -->
		<reset-password 
			v-model="resetPassword_display"
			:oid="resetPassword_oid"
			:code="resetPassword_code"
			:phone="resetPassword_phone"
			@success="handleResetPasswordSuccess"
		></reset-password>
		<!-- 重置密码弹出框弹出框 -->
		
		<!-- 关联机构弹出框 -->
		<related-organization 
			v-model="relatedOrganization_display"
			:uid="relatedOrganization_uid"
			:oid="relatedOrganization_oid"
		></related-organization>
		<!-- 关联机构弹出框 -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import { mapState } from 'vuex';
	import BaseMethods from '../../../../assets/js/base.js';
	import ResetPassword from './components/reset_password.vue';
	import RelatedOrganization from './components/related_organization.vue';
	
	export default {
		data () {
			return {
				loading: false,
				tableData: [],
				
				currentPage: 1,
				total: 0,
				
				backer_name: '',
				backer_phone: '',
				backer_creater: '',
				backer_startTime: '',
				backer_endTime: '',
				
				addBacker_popup_display: false,
				addBacker_name: '',
				addBacker_phone: '',
				addBacker_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				addBackerName_tip: false,
				addBackerPhone_tip: false,
				addBackerAddr_tip: false,
				
				viewBacker_popup_display: false,
				viewBacker_data: {},
				viewBacker_name: '',
				viewBacker_code: '',
				viewBacker_creater: '',
				viewBacker_creatDate: '',
				viewBacker_updater: '',
				viewBacker_updateDate: '',
				
				updateBacker_popup_display: false,
				updateBacker_id: '',
				updateBacker_code: '',
				updateBacker_name: '',
				updateBacker_phone: '',
				updateBacker_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				updateBackerName_tip: false,
				updateBackerPhone_tip: false,
				updateBackerAddr_tip: false,
				
				resetPassword_display: false,
				resetPassword_phone: '',
				resetPassword_code: '',
				resetPassword_oid: '',
				
				relatedOrganization_display: false,
				relatedOrganization_uid: '',
				relatedOrganization_oid: ''
			}
		},
		computed: {
			...mapState(['authInfo', 'allDisease'])
		},
		mounted () {
			this.getUserList();
		},
		methods: {
			/************************ @Ajax *******************************/
			// 请求数据
			getUserList () {
				const that = this;
				that.loading = true;
				var _requestData = { 
					creater: that.backer_creater,
					endTime: that.backer_endTime,
					limit: 10,
					pageNum: that.currentPage,
					startTime: that.backer_startTime,
					uareaCode: null,
					ucityCode: null,
					ucode: null,
					udiseasesId: null,
					uenterpriseName: null,
					ufinderCategory: 1,
					uid: null,
					uloginerCategory: that.authInfo.ucategory,
					uphone: that.backer_phone,
					uprovinceCode: null,
					username: that.backer_name,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 1
				};
				Api.findUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							that.tableData.push({
								id: res.data.data.data[i].uid,
								oid: res.data.data.data[i].uenterpriseId,
								name: res.data.data.data[i].name || '',
								code: res.data.data.data[i].ucode || '',
								phone: res.data.data.data[i].phone || '',
								creater: res.data.data.data[i].creater || '',
								creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : '',
								provinceName: res.data.data.data[i].uprovinceName || '',
								provinceCode: res.data.data.data[i].uprovinceCode || '',
								cityName: res.data.data.data[i].ucityName || '',
								cityCode: res.data.data.data[i].ucityCode || '',
								areaName: res.data.data.data[i].uareaName || '',
								areaCode: res.data.data.data[i].uareaCode || '',
								updater: res.data.data.data[i].updater || '',
								updateDate: res.data.data.data[i].updateTime ? res.data.data.data[i].updateTime.split("T")[0] : ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除用户
			deleteUser(uid, oid) {
				const that = this;
				that.loading = true;
				var _requestData = {
					uCategory: 1,
					uId: uid,
					uenterpriseId: oid
				};
				Api.deleteUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.currentPage = 1;
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchStartTimeClick () {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick () {
				this.compareSearchTime();
			},
			// 点击查询
			handleSearchClick () {
				this.currentPage = 1;
				this.getUserList();
			},
			// 点击页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getUserList();
				}
			},
			// 导出Excel数据
			exportExcel () {
				const that = this;
				that.loading = true;
				var _requestData = { 
					creater: that.backer_creater,
					endTime: that.backer_endTime,
					limit: 10000,
					pageNum: 1,
					startTime: that.backer_startTime,
					uareaCode: null,
					ucityCode: null,
					ucode: null,
					udiseasesId: null,
					uenterpriseName: null,
					ufinderCategory: 1,
					uid: null,
					uloginerCategory: that.authInfo.ucategory,
					uphone: that.backer_phone,
					uprovinceCode: null,
					username: that.backer_name,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 2
				};
				Api.findUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '序号,姓名,账号,手机号,创建人,创建时间,\n';
						for (var i = 0;i < res.data.data.data.length;i++) {
							str += `${ i+1 },${ res.data.data.data[i].name || '' },${ res.data.data.data[i].ucode || '' }\t,${ res.data.data.data[i].phone || '' }\t,${ res.data.data.data[i].creater || '' },${ res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : '' }\t,\n`;
							// data.push({
							// 	name: res.data.data.data[i].name || '',
							// 	code: res.data.data.data[i].ucode || '',
							// 	phone: res.data.data.data[i].phone || '',
							// 	creater: res.data.data.data[i].creater || '',
							// 	creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : ''
							// });
						}
						BaseMethods.outputExcel(str, '后台用户');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击新增
			handleAddBackerClick () {
				this.addBacker_name = '';
				this.addBacker_phone ='';
				this.addBacker_addr = {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				};
				this.addBackerName_tip =false;
				this.addBackerPhone_tip = false;
				this.addBackerAddr_tip = false;
				this.addBacker_popup_display = true;
			},
			// 新增地址省份选择
			handleAddBackerAddrProvinceSelect (data) {
				this.addBacker_addr.provinceName = data.code ? data.value : '';
				this.addBacker_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 新增地址城市选择
			handleAddBackerAddrCitySelect (data) {
				this.addBacker_addr.cityName = data.code ? data.value : '';
				this.addBacker_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 新增地址区域选择
			handleAddBackerAddrAreaSelect (data) {
				this.addBacker_addr.areaName = data.code ? data.value : '';
				this.addBacker_addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击新增后台管理者弹框添加按钮
			handleAddBackerPopupConfirmClick () {
				const that = this;
				if (!that.addBacker_name.trim()) {
					that.addBackerName_tip = true;
					return false;
				} else {
					that.addBackerName_tip = false;
				}
				if (!that.phoneReg.test(that.addBacker_phone)) {
					that.addBackerPhone_tip = true;
					return false;
				} else {
					that.addBackerPhone_tip = false;
				}
				if (!that.addBacker_addr.areaCode) {
					that.addBackerAddr_tip = true;
					return false;
				} else {
					that.addBackerAddr_tip = false;
				}
				that.loading = true;
				var _requestData = {
					"id": null,
					"openUmBUserVo": {
						"isExamine": null,
						"uareaCode": that.addBacker_addr.areaCode,
						"uareaName": that.addBacker_addr.areaName,
						"ucategory": 1,
						"ucategorySpecific": null,
						"ucityCode": that.addBacker_addr.cityCode,
						"ucityName": that.addBacker_addr.cityName,
						"ucode": that.addBacker_phone,
						"ucreate": null,
						"ucreateTs": null,
						"uenterpriseId": "root",
						"uexpert": that.getAllDisease().join(','),
						"uid": null,
						"ulevel": null,
						"uname": that.addBacker_name,
						"unationalityCode": null,
						"unationalityName": null,
						"uphone": that.addBacker_phone,
						"uprovinceCode": that.addBacker_addr.provinceCode,
						"uprovinceName": that.addBacker_addr.provinceName,
						"usex": null
					},
					"openUmWUserVo": {
						"u_r_name": null,
						"uaddressToAreaCode": null,
						"uaddressToAreaName": null,
						"uaddressToCityCode": null,
						"uaddressToCityName": null,
						"uaddressToNationalityCode": null,
						"uaddressToNationalityName": null,
						"uaddressToProvinceCode": null,
						"uaddressToProvinceName": null,
						"uage": null,
						"uareaCode": null,
						"uareaName": null,
						"uattendingDoctor": null,
						"ucityCode": null,
						"ucityName": null,
						"ucode": null,
						"uid": null,
						"uleftCva": null,
						"uleftNeva": null,
						"umemo": null,
						"unationalityCode": null,
						"unationalityName": null,
						"uoverspreadEye": null,
						"uphone": null,
						"uprovinceCode": null,
						"uprovinceName": null,
						"urightCva": null,
						"urightNeva": null,
						"usex": null
					},
					"type": "b",
					"ucode": that.authInfo.ucode
				};
				Api.addUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.addBacker_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击查看
			handleViewBackerClick (data) {
				this.viewBacker_data = data;
				this.viewBacker_name = data.name;
				this.viewBacker_code = data.code;
				this.viewBacker_creater = data.creater;
				this.viewBacker_creatDate = data.creatDate;
				this.viewBacker_updater = data.updater;
				this.viewBacker_updateDate = data.updateDate;
				this.viewBacker_popup_display = true;
			},
			// 点击修改
			handleUpdateBackerClick () {
				var data = this.viewBacker_data;
				this.viewBacker_popup_display = false;
				this.updateBacker_id = data.id;
				this.updateBacker_code = data.code;
				this.updateBacker_name = data.name;
				this.updateBacker_phone = data.phone;
				this.updateBacker_addr.provinceName = data.provinceName;
				this.updateBacker_addr.provinceCode = data.provinceCode;
				this.updateBacker_addr.cityName = data.cityName;
				this.updateBacker_addr.cityCode = data.cityCode;
				this.updateBacker_addr.areaName = data.areaName;
				this.updateBacker_addr.areaCode = data.areaCode;
				this.updateBackerName_tip = false;
				this.updateBackerPhone_tip = false;
				this.updateBackerAddr_tip = false;
				this.updateBacker_popup_display = true;
			},
			// 修改后台用户地址省份选择
			handleUpdateBackerAddrProvinceSelect (data) {
				this.updateBacker_addr.provinceName = data.code ? data.value : '';
				this.updateBacker_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 修改后台用户地址城市选择
			handleUpdateBackerAddrCitySelect (data) {
				this.updateBacker_addr.cityName = data.code ? data.value : '';
				this.updateBacker_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 修改后台用户地址区域选择
			handleUpdateBackerAddrAreaSelect (data) {
				this.updateBacker_addr.areaName = data.code ? data.value : '';
				this.updateBacker_addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击修改后台管理者弹框确定按钮
			handleUpdateBackerPopupConfirmClick () {
				const that = this;
				if (!that.updateBacker_name.trim()) {
					that.updateBackerName_tip = true;
					return false;
				} else {
					that.updateBackerName_tip = false;
				}
				if (!that.phoneReg.test(that.updateBacker_phone)) {
					that.updateBackerPhone_tip = true;
					return false;
				} else {
					that.updateBackerPhone_tip = false;
				}
				if (!that.updateBacker_addr.areaCode) {
					that.updateBackerAddr_tip = true;
					return false;
				} else {
					that.updateBackerAddr_tip = false;
				}
				that.loading = true;
				var _requestData = {
					"age": null,
					"name": that.updateBacker_name,
					"phone": that.updateBacker_phone,
					"uareaCode": that.updateBacker_addr.areaCode,
					"uareaName": that.updateBacker_addr.areaName,
					"uattendingDoctor": null,
					"ucategory": 1,
					"ucityCode": that.updateBacker_addr.cityCode,
					"ucityName": that.updateBacker_addr.cityName,
					"ucode": that.updateBacker_code,
					"uenterpriseId": "root",
					"uexpert": that.getAllDisease().join(','),
					"uid": that.updateBacker_id,
					"unationalityCode": null,
					"unationalityName": null,
					"uprovinceCode": that.updateBacker_addr.provinceCode,
					"uprovinceName": that.updateBacker_addr.provinceName
				};
				Api.updateUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateBacker_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击重置密码
			handleResetPasswordClick (data) {
				this.resetPassword_phone = data.phone;
				this.resetPassword_code = data.code;
				this.resetPassword_oid = data.oid;
				this.resetPassword_display = true;
			},
			// 重置密码成功
			handleResetPasswordSuccess (msg) {
				this.$message.success(msg);
				this.resetPassword_display = false;
			},
			// 点击关联机构
			handleRelatedOrganizationClick(obj) {
				this.relatedOrganization_uid = obj.id;
				this.relatedOrganization_oid = obj.oid;
				this.relatedOrganization_display = true;
			},
			// 点击删除
			handleDeleteClick(msg) {
				const that = this;
				that.$confirm(
					'此操作将删除该用户，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteUser(msg.id, msg.oid);
					}
				).catch(
					() => {}
				);
			},
			
			/************************ @Function *******************************/
			// 比较开始时间和结束时间
			compareSearchTime() {
				if (this.backer_startTime && this.backer_endTime) {
					var startTime = new Date(this.backer_startTime).getTime(),
						endTime = new Date(this.backer_endTime).getTime();
					if (endTime < startTime) {
						this.backer_endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			},
			// 获取所有的病理类型
			getAllDisease() {
				var result = [];
				this.allDisease.forEach(v => {
					result.push(v.id);
				});
				return result;
			}
		},
		components:{
			ResetPassword,
			RelatedOrganization
		}
	}
</script>

<style scoped>
	.business_user_backer{ width: 100%;height: 100%;padding: 15px;border: 1px solid #ccc;border-radius: 5px;background: #fff;overflow-y: auto; }
</style>
